import { ReactNode } from "react";

export function MarketingHeroBackground({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`relative overflow-hidden bg-[rgba(26,26,31,0.94)] ${className}`}
    >
      <div
        aria-hidden
        className="absolute inset-0 bg-[radial-gradient(ellipse_82%_112%_at_top_left,rgba(255,255,255,0.62)_0%,rgba(255,255,255,0.36)_16%,rgba(120,156,255,0.38)_32%,rgba(79,124,255,0.2)_50%,transparent_74%),radial-gradient(ellipse_62%_80%_at_78%_24%,rgba(255,255,255,0.68)_0%,rgba(255,255,255,0.3)_24%,rgba(105,143,255,0.22)_42%,transparent_70%),radial-gradient(ellipse_76%_92%_at_bottom_right,rgba(126,171,255,0.42)_0%,rgba(255,255,255,0.16)_22%,rgba(76,124,255,0.18)_44%,transparent_76%),linear-gradient(180deg,rgba(117,155,255,0.18)_0%,rgba(255,255,255,0.05)_18%,rgba(255,255,255,0)_42%)]"
      />
      <div
        aria-hidden
        className="absolute left-[-4rem] top-10 h-80 w-80 rounded-full bg-[#4f7cff]/48 blur-3xl"
      />
      <div
        aria-hidden
        className="absolute right-[6%] top-[12%] h-80 w-80 rounded-full bg-white/60 blur-3xl"
      />
      <div
        aria-hidden
        className="absolute left-[12%] top-[5%] h-72 w-72 rounded-full bg-white/48 blur-3xl"
      />
      <div
        aria-hidden
        className="absolute bottom-[10%] right-[16%] h-60 w-60 rounded-full bg-[#7ca7ff]/38 blur-3xl"
      />
      <div className="relative z-10">{children}</div>
    </div>
  );
}

export function MarketingCard({
  children,
  className = "",
  contentClassName = "",
  featured = false,
}: {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  featured?: boolean;
}) {
  return (
    <div
      className={`relative transition-transform duration-200 hover:-translate-y-1 ${
        featured
          ? "rounded-[1.7rem] bg-[linear-gradient(135deg,#ff5b92_0%,#ffb347_18%,#d6f72f_34%,#4ce1d2_52%,#4f7cff_70%,#d66dff_86%,#ff5b92_100%)] p-[2px] shadow-[0_28px_68px_rgba(255,91,146,0.14)]"
          : "rounded-[1.6rem] border border-white/70 bg-[linear-gradient(180deg,#fffefe_0%,#fff6fa_42%,#ffeef6_100%)] shadow-[0_24px_60px_rgba(34,50,120,0.10)]"
      } ${className}`}
    >
      <div
        className={`relative h-full overflow-hidden bg-[linear-gradient(180deg,#fffefe_0%,#fff6fa_42%,#ffeef6_100%)] ${
          featured ? "rounded-[calc(1.7rem-2px)]" : "rounded-[1.6rem]"
        } ${contentClassName}`}
      >
        <div
          aria-hidden
          className="absolute inset-0 bg-[linear-gradient(180deg,rgba(228,236,255,0.96)_0%,rgba(255,246,250,0.92)_34%,rgba(255,234,243,0.72)_100%)]"
        />
        <div
          aria-hidden
          className="absolute -right-10 -top-10 h-36 w-36 rounded-full bg-[#ffd8e8]/80 blur-3xl"
        />
        <div
          aria-hidden
          className="absolute -left-10 bottom-10 h-32 w-32 rounded-full bg-[#dfe7ff]/75 blur-3xl"
        />
        <div className="absolute inset-x-0 top-0 h-px bg-[linear-gradient(90deg,rgba(42,55,184,0)_0%,rgba(42,55,184,0.25)_50%,rgba(42,55,184,0)_100%)]" />
        <div className="relative z-10 h-full">{children}</div>
      </div>
    </div>
  );
}
